module.exports = __webpack_public_path__ + "img/logo.c1b28028.png";